export default __webpack_public_path__ + "static/media/qd.bc82dd3b.png";